import { ApiError } from '../api'

/**
 * Renders an RFC 9457 problem document.
 *
 * A 402 is not an error the user made — it is a limit they have reached — so it is
 * shown as an upgrade prompt rather than a failure (spec §6.3).
 */
export function ProblemBanner({ error }: { error: unknown }) {
  if (!error) return null

  if (error instanceof ApiError && error.isQuota) {
    const { tier, current, limit, upgradeUrl, detail } = error.problem
    return (
      <div className="problem quota" role="status">
        <strong>{error.problem.title}</strong>
        <p>{detail}</p>
        <p className="muted">
          {tier} tier: {current} of {limit}
        </p>
        {upgradeUrl ? (
          <a className="button primary" href={upgradeUrl}>
            See plans
          </a>
        ) : null}
      </div>
    )
  }

  const message = error instanceof Error ? error.message : 'Something went wrong.'
  const fields = error instanceof ApiError ? (error.problem.errors ?? []) : []
  return (
    <div className="problem" role="alert">
      <strong>{message}</strong>
      {fields.length > 0 ? (
        <ul>
          {fields.map((field) => (
            <li key={`${field.field}:${field.rule}`}>
              <code>{field.field}</code> — {field.rule}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
